import { atom } from "jotai";

import {
  DiningBookingWizardCurrentStepAtom,
  DiningBookingWizardListOfStepsAtom,
} from "../../stores";

export const goToNextDiningStepAtom = atom(null, (get, set) => {
  const steps = get(DiningBookingWizardListOfStepsAtom);
  const currentStep = get(DiningBookingWizardCurrentStepAtom);

  if (!currentStep || steps.length === 0) {
    return;
  }

  const currentIndex = steps.indexOf(currentStep);
  const isLastStep = currentIndex === steps.length - 1;

  if (isLastStep || currentIndex === -1) {
    return;
  }

  const nextStep = steps[currentIndex + 1];
  set(DiningBookingWizardCurrentStepAtom, nextStep);
});
